<template>
    <div>
        <CHeader class="bg-dark position-relative">
            <div class="mt-2" style="margin: 0 12%;">
                <div style="width: 200px !important;">
                    <img :src="companyLogo" alt="Logo empresa" block class="w-100 h-100">
                </div>
            </div>
        </CHeader>
        <div style="margin: 0 12%;">
            <CCard class="mt-5">
                <CCardHeader>
                    <h2>Actualizaciion datos de cliente</h2>
                </CCardHeader>
                <CCardBody>
                    <CRow>
                        <CCol>
                            <span>Fecha Registro:</span>
                            <span>{{ fechaActual }}</span>
                        </CCol>
                    </CRow>
                    <CRow class="bg-dark">
                        <CCol col="12">
                            <h4 class="text-secondary text-center my-2">Informaci&oacute;n general</h4>
                        </CCol>
                    </CRow>
                </CCardBody>
            </CCard>
        </div>
    </div>
</template>
<script>
    import moment from "moment"
    import { getCompanyLogo } from "../general"

    export default {
        data() {
            return {
                loading: false,
                isValidForm: false,
                companyLogo: "",
                fechaActual: ""
        }
    },
    methods: {
        moment
    },
    async mounted() {
        const { companyLogo } = await getCompanyLogo()
        
        this.companyLogo = companyLogo
        this.fechaActual = moment().format("DD/MM/YYYY")


    },
    computed: {

    }
  }
</script>